import { createMigration } from './utils';

export const migrationTo9_195 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            map.get('children').forEach((child, ci) => {
                const hasPolygonMask = child.get('mask') && child.getIn(['mask', 'classType']) === 'PolygonMask';
                const hasAnimationConfig = child.get('animationConfig').length !== 0;
                if (hasPolygonMask && hasAnimationConfig) {
                    child.get('animationConfig').forEach((animation, ai) => {
                        const lastPointIndex = animation.getIn(['curve', 'points']).count() - 1;
                        const pointValue = animation.getIn(['curve', 'points', lastPointIndex, 'position', 'y']);
                        // ensure the curve doesn't go beyond 1.0
                        if (pointValue > 1.0) {
                            map.setIn(['children', ci, 'animationConfig', ai, 'curve', 'points', lastPointIndex, 'position', 'y'], 1.0);
                        }
                    });
                }
            });
        });
    },
});
